import { render, staticRenderFns } from "./qspi.vue?vue&type=template&id=393815a9&scoped=true"
import script from "./qspi.vue?vue&type=script&lang=js"
export * from "./qspi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393815a9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('393815a9')) {
      api.createRecord('393815a9', component.options)
    } else {
      api.reload('393815a9', component.options)
    }
    module.hot.accept("./qspi.vue?vue&type=template&id=393815a9&scoped=true", function () {
      api.rerender('393815a9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/myTask/qspi.vue"
export default component.exports